import { isPlatform } from "@ionic/vue";
const clickListener = (el, binding, vnode, prevVnode) => {
    if (!isPlatform("desktop") || binding.value?.force === true) {
        //vnode.ctx.emit("mobile-click");
        binding.value?.onMobileClick();
    }
};
const ClickableOnMobile = {
    created(el, binding, vnode, prevVnode) {
        el.addEventListener("click", () => clickListener(el, binding, vnode, prevVnode));
    },
    unmounted(el, binding, vnode, prevVnode) {
        el.removeEventListener("click", () => clickListener(el, binding, vnode, prevVnode));
    },
};
export default ClickableOnMobile;
